/**
 * LossIcon — sanitized from `assets/newSvg/loss.svg`.
 * Artboard: 1024×1024 · viewBox 0 0 24 24 (fixed).
 */
import React from 'react';
import Svg, { Path } from 'react-native-svg';
import {
  APP_ICON_VIEW_BOX,
  useAppIconProps,
  type AppIconProps,
} from './iconBase';

export function LossIcon(props: AppIconProps) {
  const { size, color, style, accessibilityLabel, testID, ...rest } = useAppIconProps(props);

  return (
    <Svg
      width={size}
      height={size}
      viewBox={APP_ICON_VIEW_BOX}
      style={style}
      accessibilityLabel={accessibilityLabel}
      testID={testID}
      {...rest}
    >
      <Path
        d="M6,13 C8.20914,13 10,14.7909 10,17 C10,19.2091 8.20914,21 6,21 C3.79086,21 2,19.2091 2,17 C2,14.7909 3.79086,13 6,13 Z M18,13 C20.2091,13 22,14.7909 22,17 C22,19.2091 20.2091,21 18,21 C15.7909,21 14,19.2091 14,17 C14,14.7909 15.7909,13 18,13 Z M14.0379,7.62366 L16.4142,10 L18,10 C18.5523,10 19,10.4477 19,11 C19,11.5523 18.5523,12 18,12 L16.2071,12 C15.8093,12 15.4278,11.842 15.1465,11.5607 L13.9545,10.3686 L11.3218,12.6722 L12.6389,14.2088 C12.8719,14.4806 13,14.8269 13,15.185 L13,19 C13,19.5523 12.5523,20 12,20 C11.4477,20 11,19.5523 11,19 L11,15.3699 L8.56286,12.5266 C8.02761,11.9021 8.09503,10.9631 8.71399,10.4215 L11.9895,7.55546 C12.5838,7.03544 13.4795,7.06526 14.0379,7.62366 Z M16,3 C17.1046,3 18,3.89543 18,5 C18,6.10457 17.1046,7 16,7 C14.8955,7 14,6.10457 14,5 C14,3.89543 14.8955,3 16,3 Z"
        fill={color}
      />
    </Svg>
  );
}

export default LossIcon;
